export default {
  listRecordingsDataTableHeaderActions: 'Ações',
  listRecordingsDataTableHeaderPresentation: 'Slides',
  listRecordingsDataTableHeaderRecording: 'Gravação',
  listRecordingsDataTableHeaderTrack: 'Áudio',
  listRecordingsDataTableRowPlayAction: 'Play',
  listRecordingsEmptyStateAction: 'Clique aqui para começar',
  listRecordingsEmptyStateMessage:
    'Grave uma apresentação e ela será listada aqui.',
  listRecordingsEmptyStateTitle: 'Nenhuma gravação',
  listRecordingsNewRecordingAction: 'Começar uma nova Gravação',
  listRecordingsScreenTitle: 'Gravações',
  recordingDeleteAction: 'Apagar Gravação',
  recordingDeleteConfirmationButtonCancel: 'Cancelar',
  recordingDeleteConfirmationButtonDelete: 'Apagar Gravação',
  recordingDeleteConfirmationText:
    "Ao apagar essa Gravação os link's de compartilhamento serão desativados, deseja continuar?",
  recordingDeleteFailFeedback: 'Não foi possível apagar a Gravação',
  recordingDeleteSuccessFeedback: 'Gravação apagada com sucesso',
  recordingGetShareableUrlAction: 'Obter Link Compartilhável',
  recordingGetShareableUrlCopiedToClipboardFeedback:
    'Link copiado para a área de transferência',
  recordingGetShareableUrlUnableToCopyToClipboardFeedback:
    'Não foi possível copiar o link para a área de transferência',
  recordingGetShareableUrlUnableToGetShareableUrl:
    'Não foi possível obter o Link Compartilhável da gravação',
  recordingSendAction: 'Enviar apresentação',
  recordingSendFormButtonCancel: 'Cancelar',
  recordingSendFormButtonSend: 'Enviar apresentação',
  recordingSendFormFieldEmail: 'E-mail',
  recordingSendFormFieldEmailHelp:
    'Digite o email da pessoa que vai receber a sua apresentação',
  recordingSendFormFieldEmailPlaceholder: 'usuario@exemplo.com',
  recordingSendFormFieldMessage: 'Messagem',
  recordingSendFormFieldMessageHelp:
    'Escreva uma mensagem para enviar com sua apresentação',
  recordingSendFormFieldMessagePlaceholder:
    'Minha apresentação na Panic Lobster',
  recordingSendFormFieldType: 'Tipo de envio',
  recordingSendFormFieldTypeEmail: 'Enviar por e-mail',
  recordingSendFormFieldTypeMentors:
    'Pedir feedback para os mentores da Panic Lobster',
  recordingSendSuccessFeedback: 'Apresentação enviada com sucesso',
  recordingSendFailFeedback: 'Não foi possível enviar sua apresentação',
}
